import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import ContactViewModel from "@/models/ContactViewModel";
import { ref } from "@vue/composition-api";
export default function () {
    const contacts = ref<Array<ContactViewModel>>([]);
    const getContacts = async () => {
        await defineHeaderAxios();
        Axios.get("/api/contact")
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    contacts.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    getContacts();
    return {
        contacts,
        getContacts,
    };
}
